'use client'

import { useCallback } from 'react'
import { Tag } from '@/components/tag'
import { RestaurantCitySearchFiltersInput } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-filters-input'
import { RestaurantCitySearchFiltersOpenNow } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-filters-open-now'
import { RestaurantCitySearchSorting } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-sorting'
import {
    IRestaurantDisplayTagsRenderTag,
    RestaurantCitySearchFiltersDisplayTagsDesktop,
} from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/tags/desktop/restaurant-city-search-filters-display-tags-desktop'
import { RestaurantCitySearchFiltersSelectTagsDesktop } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/tags/desktop/restaurant-city-search-filters-select-tags-desktop'

export const RestaurantCitySearchFiltersDesktop = () => {
    const renderTag = useCallback<IRestaurantDisplayTagsRenderTag>((tag, { toggleTag }) => {
        return <Tag active tag={tag} onClick={toggleTag} />
    }, [])

    return (
        <div className="hidden md:block">
            <div className="flex flex-col w-full gap-y-8 md:gap-y-10">
                <div className="flex flex-col md:flex-row items-center w-full gap-x-8">
                    <div className="w-full px-6 md:px-0 md:mb-0 mb-4">
                        <RestaurantCitySearchFiltersInput />
                    </div>

                    <div className="restaurant-city-search-filters-tags-container overflow-x-scroll scrollbar-hide">
                        <RestaurantCitySearchFiltersSelectTagsDesktop />
                    </div>
                </div>

                <div className="w-full flex flex-row justify-between items-center">
                    <div className="flex flex-row items-center gap-x-8">
                        <RestaurantCitySearchFiltersOpenNow />

                        <div className="flex items-center gap-x-3">
                            <RestaurantCitySearchFiltersDisplayTagsDesktop
                                type="active"
                                renderTag={renderTag}
                            />
                        </div>
                    </div>

                    <RestaurantCitySearchSorting />
                </div>
            </div>
        </div>
    )
}
